import Environment from '../lib/Environment';
import XhrRequestHandler from '../lib/XhrRequestHandler';
import XhrRequestCache from '../lib/XhrRequestCache';
import XhrErrorListener from '../lib/XhrErrorListener';
import CryptoJS from 'crypto-js';
import { Club, ClubJSON } from './Club/Club';
import {
  AperturaAptoFisicoXTemporada,
  AperturaAptoFisicoXTemporadaJSON,
} from './AperturaAptoFisicoXTemporada/AperturaAptoFisicoXTemporada';
import { AptoFisico } from './AptoFisico/AptoFisico';
import { DocumentoTipoJSON, DocumentoTipo } from './DocumentoTipo/DocumentoTipo';
import { JugadorJSON, Jugador } from './Jugador/Jugador';

function decrypt(encryptedText: string) {
  const env = new Environment();
  const parts = encryptedText.split(':');
  const iv = CryptoJS.enc.Hex.parse(parts[0]);
  const encrypted = CryptoJS.enc.Hex.parse(parts[1]);
  const key = CryptoJS.enc.Hex.parse(CryptoJS.enc.Base64.parse(env.passphrase()).toString(CryptoJS.enc.Hex));
  // @ts-ignore
  const decrypted = CryptoJS.AES.decrypt({ ciphertext: encrypted }, key, {
    iv: iv,
    mode: CryptoJS.mode.CTR,
    padding: CryptoJS.pad.NoPadding,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

class SystemClient {
  private constructor(private requestHandler: XhrRequestHandler, private environment: Environment) {}

  static start(environment: Environment) {
    const requestHandler = new XhrRequestHandler(environment, XhrRequestCache.with([]));

    return new this(requestHandler, environment);
  }

  getEnvironment() {
    return this.environment;
  }

  unsubscribe(aListener: XhrErrorListener) {
    return this.requestHandler.unsubscribe(aListener);
  }

  subscribe(aListener: XhrErrorListener) {
    return this.requestHandler.subscribe(aListener);
  }

  async clubes() {
    const clubes = await this.requestHandler.get<ClubJSON[]>(`aptoFisicoDVM/clubes`);
    return clubes.map((c) => Club.fromJSON(c));
  }

  async documentoTipos() {
    const tipos = await this.requestHandler.get<DocumentoTipoJSON[]>(`aptoFisicoDVM/tipos-documento`);
    return tipos.map((c) => DocumentoTipo.fromJSON(c));
  }

  async aperturaVigente() {
    const apertura = await this.requestHandler.get<AperturaAptoFisicoXTemporadaJSON>(
      `aptoFisicoDVM/apertura-vigente`
    );
    return apertura ? AperturaAptoFisicoXTemporada.fromJSON(apertura) : apertura;
  }

  async puedeCargarComprobante(jugador: Jugador) {
    const ret = await this.requestHandler.get<{
      status: boolean;
      msg: string;
      showReplaceComprobante: boolean;
    }>(`aptoFisicoDVM/puede-cargar-comprobante/${jugador.getId()!}`);
    return ret;
  }

  async buscarJugador(clubId: string, documentoNumero: string, documentoTipoId: string, token: string) {
    const jugador = await this.requestHandler.post<
      JugadorJSON | null,
      { clubId: string; documentoNro: string; documentoTipo: string; token: string }
    >(`aptoFisicoDVM/jugador`, {
      clubId: clubId,
      documentoNro: documentoNumero,
      documentoTipo: documentoTipoId,
      token: token,
    });
    return jugador ? Jugador.fromJSON(jugador) : null;
  }

  async save(aptoFisico: AptoFisico, fileComprobanteMedico: File, fileSelfie: File | null, token: string) {
    var bodyFormData = new FormData();
    bodyFormData.append('comprobanteMedico', fileComprobanteMedico);
    if (fileSelfie) bodyFormData.append('selfie', fileSelfie);
    bodyFormData.append('aptoFisico', JSON.stringify(aptoFisico.toJSON()));
    bodyFormData.append('token', token);

    const data = await this.requestHandler.postWithFormData<unknown>(`aptoFisicoDVM/save`, bodyFormData);
    return data;
  }
}

export default SystemClient;
